import type { ScopedProject } from "@domain/project/project-guards";
import { Exclude, Expose, Transform } from "class-transformer";
import { IsInt, IsOptional, IsString, IsUUID, Min } from "class-validator";

export abstract class ProductConfiguration {
  @Exclude()
  protected project!: ScopedProject;

  @IsUUID()
  public readonly id: string;

  @IsString()
  public name: string;

  @IsString()
  @IsOptional()
  public positionNumber?: string;

  @Expose()
  @IsInt()
  @Min(0)
  @Transform(({ value }) => {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? Math.floor(parsedValue) : 0;
  })
  public additionalProductListQuantity: number = 0;

  protected constructor(id: string, name: string, project: ScopedProject, positionNumber?: string) {
    this.id = id;
    this.name = name;
    this.init(project);
    this.positionNumber = positionNumber;
  }

  init(project: ScopedProject) {
    this.project = project;
  }

  get productDataName(): string {
    return this.name;
  }

  get totalProductListQuantity(): number {
    return this.countPlacedProducts() + this.additionalProductListQuantity;
  }

  get owningProject(): ScopedProject {
    return this.project;
  }

  setAdditionalProductListQuantity(quantity: number) {
    this.project.setAdditionalProductListQuantity(this, quantity);
  }

  abstract get configuredProductIds(): string[];

  abstract countPlacedProducts(project?: ScopedProject): number;

  abstract get mainProductId(): string;
}
